/* eslint-disable import/prefer-default-export */
import { createIntl } from 'react-intl';
import {
  SET_LOCALE_START,
  SET_LOCALE_SUCCESS,
  SET_LOCALE_ERROR,
} from '../constants';

//import queryIntl from './intl.graphql';

function getIntlFromState(state) {
  const intl = (state && state.intl) || {};
  const { initialNow, locale, messages } = intl;
  const localeMessages = (messages && messages[locale]) || {};

  const intlProvider = createIntl({
    initialNow,
    locale,
    messages: localeMessages,
    defaultLocale: 'en-US',
  });

  return intlProvider;

}

export function getIntl() {
  return (dispatch, getState) => getIntlFromState(getState());
}

const query = `
  query ($locale:String!) {
    intl (locale:$locale) {
      id
      message
    }
  }
`;

const updatePreferredLanguageMutation = `
  mutation updatePreferredLanguage($preferredLanguage: String!) {
    updatePreferredLanguage(preferredLanguage: $preferredLanguage) {
      status
    }
  }
`;

export function setLocale({ locale }) {
return async(dispatch, getState, {graphqlRequest}) => {
    dispatch({
      type: SET_LOCALE_START,
      payload: {
        locale,
      },
    });

    try {
      // WARNING !!
       // do not use client.networkInterface except you want skip Apollo store
       // use client.query if you want benefit from Apollo caching mechanisms
      const { data } = await graphqlRequest(
         query,
         { locale },
       );
      const messages = data.intl.reduce((msgs, msg) => {
        msgs[msg.id] = msg.message; // eslint-disable-line no-param-reassign
        return msgs;
      }, {});
      dispatch({
        type: SET_LOCALE_SUCCESS,
        payload: {
          locale,
          messages,
        },
      });

      // remember locale for every new request
      if (process.env.BROWSER) {
        // Llamar al servidor para persistir (Cookie + DB)
        try {
          await fetch('/set-language', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ locale })
          });
        } catch (e) {
          // Fallback: guardar cookie manualmente si falla el endpoint
          const maxAge = 3650 * 24 * 3600;
          document.cookie = `lang=${locale};path=/;max-age=${maxAge}`;
        }
      }
      return getIntlFromState(getState());
    } catch (error) {
      dispatch({
        type: SET_LOCALE_ERROR,
        payload: {
          locale,
          error,
        },
      });
      return false;
    }

    return true;
  };
}
